import { deleteClientService } from "../infrastructure/services/deleteClientService";

export const deleteClient = {
  async execute(clientId: string): Promise<void> {
    await deleteClientService.execute(clientId);
  },
};

